import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';

function getRatingClass(rating) {
  var n = parseInt(rating);
  if (n >= 5) return 'bg-emerald-50 text-emerald-700 border-emerald-200';
  if (n >= 4) return 'bg-emerald-50 text-emerald-600 border-emerald-200';
  if (n >= 3) return 'bg-amber-50 text-amber-700 border-amber-200';
  return 'bg-red-50 text-red-700 border-red-200';
}

function getTimeAgo(d) {
  if (!d) return '';
  var diff = Date.now() - new Date(d).getTime();
  var hrs = Math.floor(diff / 3600000);
  if (hrs < 1) return 'Just now';
  if (hrs < 24) return hrs + 'h ago';
  return Math.floor(hrs / 24) + 'd ago';
}

export default function ProtoSingleCard({ emp, onSelect }) {
  var cls = 'text-xs font-semibold border ' + getRatingClass(emp.overallRating);
  var subCount = emp.submissionCount + ' submission' + (emp.submissionCount > 1 ? 's' : '');
  var timeStr = getTimeAgo(emp.lastSubmission);

  return (
    <Card
      className="border border-slate-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer"
      onClick={function() { onSelect(emp); }}
      data-testid={'entity-' + emp.empId}
    >
      <CardContent className="pt-5 pb-4 space-y-3">
        <div className="flex items-start justify-between">
          <div className="min-w-0">
            <p className="font-semibold text-base truncate">{emp.name}</p>
            <p className="text-xs text-muted-foreground">
              Emp #{emp.empId} &middot; {emp.department}
            </p>
          </div>
          <Badge className={cls} variant="outline">
            {emp.overallRating}/5
          </Badge>
        </div>

        <div className="flex items-center gap-1.5">
          <span className="text-xs text-muted-foreground">{emp.jobTitle}</span>
          <span className="text-xs text-muted-foreground">&middot;</span>
          <span className="text-xs text-muted-foreground">{emp.company}</span>
        </div>

        <PeriodBadges periods={emp.periods} />

        <div className="flex items-center justify-between pt-2 border-t border-slate-100">
          <span className="text-xs text-muted-foreground">{subCount} &middot; {timeStr}</span>
          <span className="text-xs text-primary font-medium flex items-center gap-1">
            View <ArrowRight className="h-3 w-3" />
          </span>
        </div>
      </CardContent>
    </Card>
  );
}

function PeriodBadges({ periods }) {
  if (!periods || periods.length === 0) return null;
  return (
    <div className="flex gap-1.5 flex-wrap">
      {periods.map(function(p) {
        return <Badge key={p} variant="outline" className="text-xs font-normal">{p}</Badge>;
      })}
    </div>
  );
}
